import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-event',
  templateUrl: './card-event.component.html',
  styleUrls: ['./card-event.component.scss']
})
export class CardEventComponent {

  @Input()
  tag = '';

  @Input()
  headline = '';

  @Input()
  link = '';

  @Input()
  image = '';

  open() {
    window.open(this.link, '_blank').focus();
  }
}
